import React from 'react';
import { HomeScreenProps } from './types';
import View from './View';
import useViewModel from './viewModel';

export default {
    Main: (props: HomeScreenProps) => {
        const viewModelProps = useViewModel(props);
        return <View {...viewModelProps} />;
    },
    View,
    useViewModel,
};
